module.exports = __webpack_public_path__ + "img/pic1.4e4e4111.png";